// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"50ba39732b07d1261849","678":"e399a7101f2490119592","731":"d514c11a3e170a503556","843":"ec4302638027797cca24","883":"03451f480d973e0121c7"}[chunkId] + ".js";
};